// Shared polling hook — tab visibility + focus aware
// Ersetzt duplizierte Implementierungen in LiveWidgets, HeuteWidget, Werkstatt, QS.

import { useEffect } from 'react';

export function useAutoRefresh(reload: () => void, ms = 5_000, enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    const t = setInterval(reload, ms);
    const onVis = () => { if (document.visibilityState === 'visible') reload(); };
    const onFocus = () => reload();
    document.addEventListener('visibilitychange', onVis);
    window.addEventListener('focus', onFocus);
    return () => {
      clearInterval(t);
      document.removeEventListener('visibilitychange', onVis);
      window.removeEventListener('focus', onFocus);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);
}
